import React, { useEffect, useRef, useState } from 'react'
import { useCombobox } from 'downshift'
import { ArrowIcon } from 'app/React/Components/Form/ArrowIcon'
import PropTypes from 'prop-types'
import clx from 'classnames'

function sortItems (items) {
  return items
    .sort((a, b) => a.title.localeCompare(b.title))
}

export function SuperSelect(props) {
  const [inputValue, setInputValue] = useState('')
  const items = props.locations
  const [inputItems, setInputItems] = useState(sortItems(items))
  const [_selectedItem, setSelectedItem] = useState(props.location !== null ? props.location : null)
  const toggleButtonRef = useRef(null)
  const selectedItem = _selectedItem ?? props.defaultValue

  const { onChange } = props
  useEffect(() => {
    onChange(selectedItem)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem?.id])

  const {
    isOpen,
    getToggleButtonProps,
    getMenuProps,
    highlightedIndex,
    getItemProps,
    getInputProps,
    getComboboxProps
  } = useCombobox({
    items: inputItems,
    selectedItem,
    sortItems,
    onSelectedItemChange(changes) {
      setInputValue('')
      setInputItems(items)
      setSelectedItem(changes.selectedItem ?? null)
      toggleButtonRef.current?.focus()
      return changes
    }
  })

  return (
    <div {...getComboboxProps({ style: { width: '100%', position: 'relative' } })}>
      <button
        type='button'
        className={clx('select_button', { is_open: isOpen })}
        {...getToggleButtonProps({
          ref: toggleButtonRef,
          tabIndex: 0
        })}
      >
        <span
          dangerouslySetInnerHTML={{ __html: selectedItem ? selectedItem.title : 'Vælg forhandler' }}
          style={{ flex: 1 }}
        />
        <ArrowIcon/>
      </button>
      <div className={clx('select_menu_outer', { is_open: isOpen })}>
        <input
          type='text'
          className={clx('select_input', { 'visually-hidden-style': !isOpen })}
          {...getInputProps({
            value: inputValue,
            onChange: ({ currentTarget: { value: inputValue } }) => {
              setInputValue(inputValue)
              setInputItems(items
                .filter((item) => inputValue == null || item.title
                  .toLowerCase()
                  .includes(inputValue.toLowerCase())
                )
              )
            },
            tabIndex: -1
          })}
        />
        <ul className={clx('select_menu_list')} {...getMenuProps()}>
          {isOpen &&
            inputItems.map((item, index) => {
              const isActive = highlightedIndex === index
              const isSelected = selectedItem === item
              return (
                <li
                  key={`${item.id}${index}`}
                  className={clx('select_menu_list_item', { is_selected: isSelected, is_active: isActive })}
                  {...getItemProps({
                    item,
                    index
                  })}
                  dangerouslySetInnerHTML={{ __html: item.title }}
                />
              )
            })}
        </ul>
      </div>
    </div>
  )
}

const Location = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  city: PropTypes.string,
  zipcodes: PropTypes.arrayOf(PropTypes.string)
})

SuperSelect.propTypes = {
  locations: PropTypes.arrayOf(Location).isRequired,
  location: Location,
  defaultValue: Location,
  onChange: PropTypes.func
}
